let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9thXI")).then(() => parcelRequire('9LIHd'));